export default {
  dbu_content_management_center_title: '内容管理中心',
  dbu_content_management_center_subtitle: '上传、编辑并管理你的游戏数据洞察报告',
};
